module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataLoaded) ? _c('div', {
    staticClass: "navbar-bottom",
    class: {
      'iphone-x': _vm.iphoneX
    }
  }, _vm._l((_vm.navs), function(nav, index) {
    return _c('div', {
      staticClass: "nav",
      class: {
        'active': index == _vm.activeIndex
      },
      on: {
        "click": function($event) {
          return _vm.jump(nav)
        }
      }
    }, [_c('div', {
      staticClass: "nav-image"
    }, [_c('beast-image', {
      staticClass: "normal-img",
      attrs: {
        "src": nav.normalIcon
      }
    }), _vm._v(" "), _c('beast-image', {
      staticClass: "active-img",
      attrs: {
        "src": nav.activeIcon
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "nav-text"
    }, [_vm._v(_vm._s(nav.title))])])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3299ffa9"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/navbar-bottom/index.vue
// module id = 465
// module chunks = 6 13 16 22 41 72